var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.996338 19.9991C0.996338 15.9051 9.50474 12.5859 20.0003 12.5859C30.4959 12.5859 39.0043 15.9059 39.0043 19.9995C39.0043 24.0931 30.4963 27.4115 20.0003 27.4115C9.50434 27.4115 0.996338 24.0927 0.996338 19.9991Z",
    fill: "#006891"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.996338 19.9991C0.996338 15.9051 9.50474 12.5859 20.0003 12.5859C30.4959 12.5859 39.0043 15.9059 39.0043 19.9995C39.0043 24.0931 30.4963 27.4115 20.0003 27.4115C9.50434 27.4115 0.996338 24.0927 0.996338 19.9991Z",
    stroke: "#006891",
    strokeWidth: 1.40509,
    strokeMiterlimit: 3.8636
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96069 23.603L9.93309 16.2402H13.0463V20.5706H13.0667L15.1787 16.2402H18.3411L16.3687 23.603H14.3131L15.5775 18.8802H15.5571L13.0463 23.603H11.4003V18.8802H11.3667L10.1023 23.603H7.96069Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8977 23.7495L19.1777 22.7031H21.4465L21.1661 23.7495H18.8977Z",
    fill: "#EE4034"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2564 22.4082L20.404 18.1274H18.3416L18.8476 16.2402H25.2407L24.7351 18.1274H22.6727L21.5255 22.407L19.2564 22.4082Z",
    fill: "#FFC325"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7739 23.603L25.7451 16.2402H27.9731L28.9783 20.1798H28.9979L30.0531 16.2402H32.1127L30.1411 23.603H28.0215L26.9299 19.5818H26.9103L25.8335 23.603H23.7739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.59111634fc9f883c9e839c20c3f1a3a4.svg";
export { ForwardRef as ReactComponent };